<template>
  <div id="app" class="clearfix">
    <vue-loading :active.sync="is_loading" 
        :can-cancel="false"         
        :is-full-page="false">
        </vue-loading>    
    <site-navigation v-if="!hide_menu"/>
    <site-header v-if="!hide_menu"/>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
    <support-footer v-if="!hide_footer"/>
    <site-footer v-if="!hide_footer"/>    
  </div>
</template>

<script>
import SiteNavigation from "@/components/shared/site-navigation.vue";
import SiteHeader from "@/components/shared/site-header.vue";

import SupportFooter from "@/components/shared/support-footer.vue";
import SiteFooter from "@/components/shared/site-footer.vue";

import EventBus from "@/components/shared/event-bus";
import store from "@/store";

import { 
  GET_SESSION_KEY,
  PRODUCTS_FETCH,
  CART_FETCH,
  USER_FETCH
} from "@/store/actions.type";

export default {
  store: store,
  components: {
    SiteNavigation,
    SiteHeader,
    SupportFooter,
    SiteFooter,
    
  },
  data() {
    return {
      toaster: null,
      timer: null,
      is_loading: true,
      loading_message: "",
      hide_menu:false,
      hide_footer:false
    }
  },
  beforeMount() {
    this.registerListeners();
  },
  mounted() {
    store.dispatch(USER_FETCH);
    store.dispatch(GET_SESSION_KEY);        
    this.is_loading = false;
  },
  computed: {
    isValidSession () {
      return store.state.session.isValidSession;
    }
  },
  methods: {
    registerListeners() {
      var self = this;
      EventBus.$on("global_loading", function(loading) {
        self.$log.info("global_loading", loading);
        self.is_loading = loading.is_loading;
        self.loading_message = loading.loading_message || "";
      });
      EventBus.$on("hide_footer", function(hide) {
        self.$log.info("hide_footer", hide);
        self.hide_footer = hide;
      });
      EventBus.$on("hide_menu", function(hide) {
        self.$log.info("hide_menu", hide);
        self.hide_menu = hide;
      });
    }
  },
  watch: {
    isValidSession: function(newValue, oldValue) {
      if (newValue != oldValue) {
        if (!newValue) {
          this.toaster = this.$toasted.error("Network error, some services may be unavailable, please contact support.", {
            theme: "toasted-primary", 
            position: "bottom-center",
            fullWidth: true,
            fitToScreen: true,
            duration: null,
            containerClass: 'toast-danger',
            icon:'exclamation-circle',
            iconPack: 'fontawesome'
          });
        } else {
          store.dispatch(PRODUCTS_FETCH);
          store.dispatch(CART_FETCH);
        }
      }
    }
  }
};
</script>

<style lang="scss">
@import "src/styles/global.scss";
</style>
